import React, { useState } from "react";
import { ReactComponent as FilterIcon } from "../../../../assets/icons/modal/filter.svg";
import { IBrand } from "../../../../types/brands.type";
import { IProductType } from "../../../../types/productType.type";
import DateRangeInputs from "../../../inputs/DateRangeInputs/DateRangeInputs";
import DefaultModal from "../../DefaultModal/DefaultModal";
import ModalBottomButtons from "../../forms/buttons/ModakBottomButtons/ModalBottomButtons";
import SelectInput, {
  SelectOption,
} from "../../forms/inputs/SelectInput/SelectInput";
import ModalTitle from "../../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: (
    brand: SelectOption,
    type: SelectOption,
    startDate: Date | null,
    endDate: Date | null
  ) => void;
  defaultType: SelectOption;
  defaultBrand: SelectOption;
  brands: IBrand[];
  types: IProductType[];
  defaultStartDate: Date | null;
  defaultEndDate: Date | null;
}

const WarehouseFilterModal: React.FC<Props> = (props) => {
  const [type, setType] = useState<SelectOption>(
    props.defaultType || {
      value: "none",
      label: "all",
    }
  );
  const [brand, setBrand] = useState<SelectOption>(
    props.defaultBrand || {
      value: "none",
      label: "all",
    }
  );
  const [startDate, setStartDate] = useState<Date | null>(
    props.defaultStartDate
  );
  const [endDate, setEndDate] = useState<Date | null>(props.defaultEndDate);

  const allTypeSelects: SelectOption[] = [
    {
      value: "none",
      label: "all",
    },
    ...props.types.map((item) => ({
      value: item.id,
      label: item.name,
    })),
  ];

  const allBrandSelects: SelectOption[] = [
    {
      value: "none",
      label: "all",
    },
    ...props.brands.map((item) => ({
      value: item.id,
      label: item.name,
    })),
  ];

  return (
    <DefaultModal>
      <div className={styles.container}>
        <ModalTitle
          title="Фільтр"
          subTitle='Виберіть параметри фільтра для відображення потрібних даних. Після налаштування натисніть "Застосувати" для отримання результату.'
          onClose={props.onClose}
        >
          <FilterIcon />
        </ModalTitle>
        <div className={styles.form}>
          <SelectInput
            title="Brand"
            value={brand}
            values={allBrandSelects}
            onChange={(value) => setBrand(value)}
          />
          <SelectInput
            title="Type"
            value={type}
            values={allTypeSelects}
            onChange={(value) => setType(value)}
          />
          <DateRangeInputs
            start={startDate}
            onChangeStart={(value) => setStartDate(value)}
            end={endDate}
            onChangeEnd={(value) => setEndDate(value)}
          />
        </div>
        <ModalBottomButtons
          onPressApply={() => {
            props.onApply(brand, type, startDate, endDate);
            props.onClose();
          }}
          onPressBack={props.onClose}
          backTitle="Назад"
          applyTitle="Застосувати"
        />
      </div>
    </DefaultModal>
  );
};

export default WarehouseFilterModal;
